import { createContext, useContext } from 'react';

type FormsTemplatesScrollContext = {
   scrollContentToTop: VoidFunction;
};

const formsTemplatesScrollContext = createContext<FormsTemplatesScrollContext>({
   scrollContentToTop: () => undefined,
});

export const useFormsTemplatesScrollContext = (): FormsTemplatesScrollContext => {
   return useContext(formsTemplatesScrollContext);
};

const { Provider } = formsTemplatesScrollContext;

type FormsTemplatesScrollContextProviderProps = {
   readonly value: FormsTemplatesScrollContext;
   readonly children: JSX.Element;
};

export const FormsTemplatesScrollContextProvider = (props: FormsTemplatesScrollContextProviderProps): JSX.Element => {
   return <Provider value={props.value}>{props.children}</Provider>;
};
